import { toast } from 'react-toastify';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { submitApplication } from '../../../utilities/API/applicationSubmitServices';
import { searchPatientByProgram } from '../../../utilities/API/patientSearch/patientSearch';

export const patientApplicationCPR = createAsyncThunk(
  'patientApplicationCPR', searchPatientByProgram
)
export const patientApplicationFAF = createAsyncThunk(
  'patientApplicationFAF', searchPatientByProgram
)

const initialState = {
  displayList: false,
  fafApp: [],
  cprApp: [],
  caseApp: [{
    program: "Case Management",
    applicationID: "00059865",
    status: "Approved"

  }]
}

const patientApplicationListSlice = createSlice({
  name: 'patientApplication',
  initialState,
  reducers: {
    setDisplayList: (state) => {
      state.displayList = false;
    },
    setDisplayListTrue: (state) => {
      state.displayList = true;
    },
    resetPatientApplication: (state) => {
      state.displayList = false
      state.fafApp = []
      state.cprApp = []
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(patientApplicationCPR.pending, (state, action) => {
        // toast.warn("PreQualQuestions pending")
      })
      .addCase(patientApplicationCPR.fulfilled, (state, action) => {
        let response = action.payload.res;
        if (typeof response?.ResponseDetails?.App?.pxResults != 'undefined' || response?.ResponseDetails?.App?.pxResults?.length > 0) {
          let appARR = []
          response?.ResponseDetails?.App?.pxResults.map((data) => {
            let obj = {
              program: action.payload.program,
              applicationID: data.ApplicationID,
              status: data.PortalAppStatus,
              createdDateTime: data.pxCreateDateTime,
              patientID: data.PatientID,
              action: {
                uploadDoc: typeof data?.IsEligibleForDoc != 'undefined' ? data?.IsEligibleForDoc : false,
                submitClaim: typeof data.IsEligibleForClaim != 'undefined' ? data.IsEligibleForClaim : false,
              }

            }
            appARR.push(obj);
          })
          if (appARR.length > 0) {
            state.displayList = true;
            state.cprApp = appARR;
          } else {
            state.displayList = false;
          }
        }
      })
      .addCase(patientApplicationCPR.rejected, (state, action) => {
        // toast.error(action.error.message)
      })


      .addCase(patientApplicationFAF.pending, (state, action) => {
        // toast.warn("PreQualQuestions pending")
      })
      .addCase(patientApplicationFAF.fulfilled, (state, action) => {
        let response = action.payload.res;
        if (typeof response?.ResponseDetails?.App?.pxResults != 'undefined' || response?.ResponseDetails?.App?.pxResults?.length > 0) {
          let appARR = []
          response?.ResponseDetails?.App?.pxResults.map((data) => {
            let obj = {
              program: action.payload.program,
              applicationID: data.ApplicationID,
              status: data.PortalAppStatus,
              patientID: data.PatientID,
              action: {
                uploadDoc: data.IsEligibleForDoc,
                submitClaim: data.IsEligibleForClaim,
              }

            }
            appARR.push(obj);
          })
          if (appARR.length > 0) {
            state.displayList = true;
            state.fafApp = appARR;
          } else {
            state.displayList = false;
          }
        }
      })
      .addCase(patientApplicationFAF.rejected, (state, action) => {
        // toast.error(action.error.message)
      })
  },
})
export const { setDisplayList, resetPatientApplication, setDisplayListTrue } = patientApplicationListSlice.actions
export default patientApplicationListSlice.reducer